var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 41.363708,
    height: 40.987499,
    viewBox: "0 0 41.363708 40.987499",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs454"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "house",
    d: "m 0.74151565,20.6675 c -0.65,0 -1.01,-0.79 -0.5,-1.3 L 20.181516,0.2175 c 0.29,-0.29 0.72,-0.29 1.01,0 l 7.34,7.13 v -2.45 c 0,-0.43 0.36,-0.79 0.79,-0.79 h 2.16 c 0.43,0 0.72,0.36 0.72,0.79 v 5.62 c 0,0.22 0.14,0.43 0.29,0.58 l 8.64,8.28 c 0.5,0.5 0.14,1.3 -0.58,1.3 h -4.75 v 18.94 c 0,1.01 -0.36,1.37 -0.79,1.37 h -3.82 v -13.46 c 0,-0.43 -0.36,-0.79 -0.79,-0.79 h -5.9 c -0.43,0 -0.79,0.36 -0.79,0.79 v 13.46 H 6.2815157 c -0.43,0 -0.72,-0.36 -0.72,-1.37 v -18.94 H 0.74151565 Z m 9.43000035,13.61 c 0,0.43 0.36,0.79 0.79,0.79 h 5.9 c 0.43,0 0.72,-0.36 0.72,-0.79 v -6.77 c 0,-0.43 -0.29,-0.79 -0.72,-0.79 h -5.9 c -0.43,0 -0.79,0.36 -0.79,0.79 z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.576faf941bd307d505d2e3db64132fa4.svg";
export { ForwardRef as ReactComponent };